



















































import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { SfInput } from '@storefront-ui/vue';

import { useCart } from '~/modules/core/composables/useCart';
import cartGetters from '~/modules/core/getters/cartGetters';

export default defineComponent({
  name: 'CouponCode',
  components: {
    SfInput,
    VaimoButton: () => import('atoms/VaimoButton.vue')
  },
  props: {
    couponId: {
      type: String,
      default: ''
    }
  },
  setup() {
    const { cart, applyCoupon, removeCoupon, error } = useCart();

    const couponCodeUserInput = ref('');

    const couponCodeAppliedToCart = computed(
      () => cartGetters.getAppliedCoupon(cart.value)?.code
    );
    const isCouponFreeShipping = computed(
      () => cartGetters.getAppliedCoupon(cart.value)?.free_shipping_coupon
    );
    const isCouponCodeApplied = computed(
      () => couponCodeAppliedToCart.value !== undefined
    );
    const hasAnyError = computed(() =>
      Object.values(error.value).some((value) => value !== null)
    );
    const applyCouponMsg = computed<Error>(
      () =>
        error.value.applyCoupon ||
        error.value.removeCoupon || { message: '', name: 'apply-coupon' }
    );
    const applyOrRemoveCoupon = async () => {
      const operationPromise = isCouponCodeApplied.value
        ? removeCoupon({})
        : applyCoupon({ couponCode: couponCodeUserInput.value });
      await operationPromise;
      couponCodeUserInput.value = '';
    };
    const couponCodeSuccessMessage = computed(() => {
      return isCouponFreeShipping.value
        ? 'Free shipping coupon applied'
        : 'Code Applied';
    });

    return {
      couponCodeUserInput,
      couponCodeAppliedToCart,
      isCouponCodeApplied,
      applyCouponMsg,
      applyOrRemoveCoupon,
      hasAnyError,
      couponCodeSuccessMessage
    };
  }
});
